export enum PartType {
  Manager = 1,
  Administrator = 2,
  None = 3,
  Custodian = 4
}
